<script lang="ts" module>
	export interface IndeterminateProgressBarProps {
		dataCy: string;
		class?: string;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { ...props }: IndeterminateProgressBarProps = $props();

	let dataCyPrefix = $derived(`${props.dataCy}-indeterminate-progress-bar`);
</script>

<div
	data-cy={dataCyPrefix}
	class={twMerge('relative h-[0.125rem] overflow-hidden bg-gray-500', props.class)}
	role="progressbar"
>
	<div
		class="progress-1 transition-[transform 0.2s linear] absolute bottom-0 left-0 top-0 origin-left bg-gray-900"
	></div>
	<div
		class="progress-2 transition-[transform 0.2s linear] absolute bottom-0 left-0 top-0 origin-left bg-gray-900"
	></div>
</div>

<style>
	@keyframes indeterminate-progress-1 {
		0% {
			left: -35%;
			right: 100%;
		}

		60% {
			left: 100%;
			right: -90%;
		}
		100% {
			left: 100%;
			right: -90%;
		}
	}

	@keyframes indeterminate-progress-2 {
		0% {
			left: -200%;
			right: 100%;
		}

		60% {
			left: 107%;
			right: -8%;
		}
		100% {
			left: 107%;
			right: -8%;
		}
	}

	.progress-1 {
		animation: indeterminate-progress-1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
		-webkit-animation: indeterminate-progress-1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395)
			infinite;
	}

	.progress-2 {
		animation: indeterminate-progress-2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
		-webkit-animation: indeterminate-progress-2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s
			infinite;
	}
</style>
